import * as React from 'react';
import {translate} from 'react-i18next';

import {ITranslatedComponent} from '../../redux/reducers/generalReducer';
import {
    WorkflowOptionApprovalDto,
} from '../../services/Client';

import {Card, Segment} from 'semantic-ui-react';

import TextField from '../../components/TextField';
import TextPartitionContainer from './TextPartitionContainer';
import ModeltypesLine from './ModeltypesLine';
import ToggleButton from "../../components/ToggleButton";
import LastApprovalComparing from "./LastApprovalComparing/LastApprovalComparing";
import Button from "../../components/Button";

interface IOptionApprovalPropsProps extends ITranslatedComponent {
    /**
     * The group which the line belongs to
     */
    approval: WorkflowOptionApprovalDto;

    userLanguage: string;

    onApprove: (approval: WorkflowOptionApprovalDto, toggled: boolean) => void;
    onReject: (approval: WorkflowOptionApprovalDto, toggled: boolean) => void;
    onRejectMessageEntered: (approval: WorkflowOptionApprovalDto, val: string) => void;
    onClickShowHistory: (approval: WorkflowOptionApprovalDto) => void;
}

const OptionApprovalProps: React.StatelessComponent<IOptionApprovalPropsProps> = (props: IOptionApprovalPropsProps) => {
    const {t, approval, onClickShowHistory, userLanguage} = props;

    return (
        <Card>
            <Card.Content>
                <TextPartitionContainer partitions={approval.basicTexts || []} />
                <ModeltypesLine
                    assignedModeltypes={approval.assignedModeltypes}
                    userLanguage={userLanguage}
                />
            </Card.Content>
            <Card.Content extra={true}>
                <Segment.Group horizontal={true}>
                    <Segment>
                        <ToggleButton
                            toggled={approval.approved === true}
                            icon="check"
                            onClick={(toggled: boolean) => {
                                props.onApprove(approval, toggled);
                            }}
                        />
                        <ToggleButton
                            toggled={approval.approved === false}
                            icon="ban"
                            onClick={(toggled: boolean) => {
                                props.onReject(approval, toggled);
                            }}
                        />
                        {props.approval.approved === true && <span>{t("APPROVED")}</span>}
                        {props.approval.approved === false && <span>{t("REJECTED")}</span>}
                        <LastApprovalComparing
                            approval={approval}
                            userLanguage={userLanguage}
                        />
                    </Segment>
                    {props.approval.approved === false &&
                        <Segment>
                            <TextField
                              onBlur={(e, val) => { props.onRejectMessageEntered(approval, val); }}
                              placeholder={t("GLOBAL:ENTER_REASON")}
                              value={props.approval.rejectMessage}
                              className='approval_textfield'
                            />
                        </Segment>
                    }
                    <Segment>
                        <Button
                            className={'right floated'}
                            icon="history"
                            label={t("APPROVAL_VIEW:SHOW_HISTORY")}
                            labelPosition="after"
                            floated='right'
                            onClick={() => onClickShowHistory(approval)}
                        />
                    </Segment>
                </Segment.Group>
            </Card.Content>
        </Card>
    );
};

export default translate(["APPROVAL_VIEW"])(OptionApprovalProps);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/OptionApprovalProps.tsx